module.exports = __webpack_public_path__ + "img/占位-展商-详情.9ae7008f.png";